export default {
  name: '이름',
  tel: '연락처',
  save: '저장',
  confirm: '확인',
  cancel: '취소',
  delete: '삭제',
  complete: '완료',
  loading: '로딩중...',
  telEmpty: '연락처를 적어주세요',
  nameEmpty: '이름을 적어주세요',
  nameInvalid: '정확한 이름을 적어주세요',
  confirmDelete: '삭제하시겠습니까?',
  telInvalid: '정확한 연락처를 적어주세요',
  vanCalendar: {
    end: '완료',
    start: '시작',
    title: '날자 선택',
    confirm: '확인',
    startEnd: '시작/완료',
    weekdays: ['일', '월', '화', '수', '목', '금', '토'],
    monthTitle: (year,month) => `${year}년${month}월`,
    rangePrompt: (maxRange) => `선택한 일수는 ${maxRange} 일을, 초과할 수 없습니다`,
  },
  vanCascader: {
    select: '선택해 주세요',
  },
  vanContactCard: {
    addText: '연락처 추가',
  },
  vanContactList: {
    addText: '새로운 연락처',
  },
  vanPagination: {
    prev: '이전 페이지',
    next: '다음 페이지',
  },
  vanPullRefresh: {
    pulling: '내려서 새로고침...',
    loosing: '클릭 후 새로고침...',
  },
  vanSubmitBar: {
    label: '합계：',
  },
  vanCoupon: {
    unlimited: '입력값 없음',
    discount: (discount) => `${discount}할인`,
    condition: (condition) => `${condition}원 이상 시 사용 가능.`,
  },
  vanCouponCell: {
    title: '쿠폰',
    tips: '사용불가',
    count: (count) => `${count}장 사용가능`,
  },
  vanCouponList: {
    empty: '쿠폰 없음',
    exchange: '교환',
    close: '쿠폰 미적용',
    enable: '사용가능한 쿠폰',
    disabled: '사용불가한 쿠폰',
    placeholder: '쿠폰번호 입력',
  },
  vanAddressEdit: {
    area: '지역',
    postal: '우편번호',
    areaEmpty: '지역 선택',
    addressEmpty: '상세주소',
    postalEmpty: '잘못된 우편 번호',
    defaultAddress: '기본 배송지 설정',
    telPlaceholder: '받는 사람 연락처',
    namePlaceholder: '받는 사람 이름',
    areaPlaceholder: '시/구/동 선택',
  },
  vanAddressEditDetail: {
    label: '상세주소',
    placeholder: '동/호',
  },
  vanAddressList: {
    add: '주소 추가',
  },
};